export default function getUrlParameter(paramKey) {
  const urlParams = new URLSearchParams(window.location.search);
  const paramSet = urlParams.get(paramKey);
  return paramSet ? urlParams.get(paramKey) : '';
}
